import React, { useState, useEffect } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import apiClient from "../utils/apiClient";

const SignInEmail = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [errorShow, setErrorShow] = useState(false);
  const [error, setError] = useState();

  const validateEmailAllowed = (email) => {
    if (!email || !props.allowedEmails) return false;
    const emailDomain = email.split("@")[1];
    return emailDomain === "iamclearmind.com" && props.allowedEmails.includes(email);
  };

  const signInWithEmail = () => {
    if (!email || !password) {
      setErrorShow(true);
      setError("Email and Password are required.");
      return;
    }

    // Check if email is allowed from DB list
    if (!validateEmailAllowed(email)) {
      setErrorShow(true);
      setError(`Access denied. Email not verified !!`);
      return;
    }

    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then(async (response) => {
        if (response) {
          console.log("Sign-in Successful !!");
          // Fetch specific user access
          try {
            const accessResponse = await apiClient.get(`user-access?email=${email}`);
            if (accessResponse.data.status === "success") {
              localStorage.setItem("user_access", JSON.stringify(accessResponse.data.access));
              console.log("User access stored:", accessResponse.data.access);
            }
          } catch (accessError) {
            console.error("Error fetching user access:", accessError);
          }
          // Add any additional logic here for successful sign-in
        }
      })
      .catch((err) => {
        setErrorShow(true);
        
        // Provide more specific error messages
        switch (err.code) {
          case 'auth/user-not-found':
            setError("No account found with this email address.");
            break;
          case 'auth/wrong-password':
            setError("Incorrect password. Please try again.");
            break;
          case 'auth/invalid-email':
            setError("Invalid email format.");
            break;
          case 'auth/user-disabled':
            setError("This account has been disabled.");
            break;
          case 'auth/too-many-requests':
            setError("Too many failed attempts. Please try again later.");
            break;
          default:
            setError("Invalid Credentials. Please Try again");
        }
      });
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      signInWithEmail();
    }
  };

  useEffect(() => {
    if (errorShow) {
      setErrorShow(true);
      const toRef = setTimeout(() => {
        setErrorShow(false);
        clearTimeout(toRef);
      }, 3000);
    }
  }, [errorShow]);

  return (
    <div className="max-w-screen-xl w-full relative rounded-lg font-poppins">

      <div className="text-white font-semibold text-center text-2xl w-full py-4">
         Login with Email
      </div>
      <div className={"w-[100%] md:w-[100%]  text-left py-2 text-gray-100"}>
        <input
          type="email"
          className={
            "w-[100%] py-3 text-left bg-white/10  text-gray-100  rounded-[6px] px-3 text-base "
          }
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>
      <div
        className={"w-[100%] md:w-[100%] mt-1  text-left py-2 text-gray-100"}
      >
        <input
          type="password"
          className={
            "w-[100%] text-left  py-3 bg-white/10 text-gray-100 rounded-[6px] px-3  "
          }
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>
      <div className="w-full flex justify-start pb-2 mt-8">
        <button
          onClick={() => props.setOpenForgotPassword(true)}
          className="flex flex-row items-center justify-center rounded-lg  text-white"
        >
          <div className="ml-1 select-none">Forgot your password?</div>
        </button>
      </div>
      <div>
        {" "}
        <button
          onClick={signInWithEmail}
          disabled={!email || !password}
          className="flex flex-row items-center disabled:cursor-not-allowed disabled:opacity-50 justify-center py-2.5 w-full mb-3 rounded-[8px] bg-[#07F2C7] text-white font-medium hover:bg-[#07F2C7]/90 ease-linear duration-150"
        >
          <div className="ml-4 select-none text-black">Login</div>
        </button>
      </div>
      {errorShow === true ? (
        <div className="w-96  flex p-2 mt-2">
          <div className="text-[#D1433A] text-base font-semibold -mt-0.5">
            {error ? error : ""}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SignInEmail;
































































































// import React, { useState, useEffect } from "react";
// import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

// const SignInEmail = (props) => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const [errorShow, setErrorShow] = useState(false);
//   const [error, setError] = useState();

//   const signInWithEmail = () => {
//     if (!email || !password) {
//       setErrorShow(true);
//       setError("Email and Password are required.");
//     } else {
//       const auth = getAuth();
//       signInWithEmailAndPassword(auth, email, password)
//         .then((response) => {
//           if (response) {
//           }
//         })
//         .catch((err) => {
//           setErrorShow(true);
//           setError("Invalid Credentials. Please Try again");
//         });
//     }
//   };

//   useEffect(() => {
//     if (errorShow) {
//       setErrorShow(true);
//       const toRef = setTimeout(() => {
//         setErrorShow(false);
//         clearTimeout(toRef);
//       }, 3000);
//     }
//   }, [errorShow]);
//   return (
//     <div className="max-w-screen-xl w-full relative rounded-lg font-poppins">
//       <div className={"w-[100%] md:w-[100%]  text-left py-2 text-gray-100"}>
//         <input
//           type="email"
//           className={
//             "w-[100%] py-3 text-left bg-white/10  text-gray-100  rounded-[6px] px-3 text-base "
//           }
//           placeholder="Enter your email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         />
//       </div>
//       <div
//         className={"w-[100%] md:w-[100%] mt-1  text-left py-2 text-gray-100"}
//       >
//         <input
//           type="password"
//           className={
//             "w-[100%] text-left  py-3 bg-white/10 text-gray-100 rounded-[6px] px-3  "
//           }
//           placeholder="Enter your password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />
//       </div>
//       <div className="w-full flex justify-start pb-2 mt-8">
//         <button
//           onClick={() => props.setOpenForgotPassword(true)}
//           className="flex flex-row items-center justify-center rounded-lg  text-white"
//         >
//           <div className="ml-1 select-none">Forgot your password?</div>
//         </button>
//       </div>
//       <div>
//         {" "}
//         <button
//           onClick={signInWithEmail}
//           disabled={!email || !password}
//           className="flex flex-row items-center justify-center py-2.5 w-full mb-3 rounded-[8px] bg-[#07F2C7] text-white font-medium hover:bg-[#07F2C7]/90 ease-linear duration-150"
//         >
//           <div className="ml-4 select-none text-black">Login</div>
//         </button>
//       </div>
//       {errorShow === true ? (
//         <div className="w-96 bg-white flex p-2 mt-2">
//           <div className="text-[#D1433A] text-base font-bold -mt-0.5">
//             {error ? error : ""}
//           </div>
//         </div>
//       ) : null}
//     </div>
//   );
// };

// export default SignInEmail;
